module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0137.jpg?v=b86bf1d0";